// This file is to async load external library and add into global

import { GOOGLE_MAP_API_KEY } from './key';

const insertScript = (id, src, options = { async: true, defer: true }) => {
	if (document.getElementById(id)) {
		return 1;
	}

	const jss = document.getElementsByTagName('script')[0];
	const js = document.createElement('script');

	js.id = id;
	js.src = src;

	if (options.async) {
		js.async = true;
	}

	if (options.defer) {
		js.defer = true;
	}

	jss.parentNode.insertBefore(js, jss);
	return 0;
};

export const loadGoogleMapLibrary = () =>
	new Promise(resolve => {
		window.initMap = () => resolve();

		const result = insertScript(
			'google-map-jssdk',
			`//maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&callback=initMap`,
		);

		// Aready insert
		if (result === 1) {
			resolve();
		}
	});



// WEBPACK FOOTER //
// ./src/util/script.js